// Central course data for cards and dynamic pages (orange-themed)
export const courses = [
  {
    slug: "frontend-web-development",
    title: "Frontend Web Development",
    short: "Build modern, responsive web apps with HTML, CSS, JavaScript, React and TailwindCSS.",
    level: "Beginner → Intermediate",
  duration: "2 months",
    icon: "Code2",
  image: "/images/webdevelopmet.webp",
    modules: [
      "Semantic HTML & accessibility",
      "Modern CSS & TailwindCSS",
      "JavaScript ES6+ fundamentals",
      "React components & hooks",
      "State management & routing",
      "API integration & deployment"
    ],
    outcomes: [
      "Build responsive layouts with TailwindCSS",
      "Create interactive React components",
      "Handle state & side effects",
      "Deploy production-ready apps"
    ],
    tools: ["HTML", "CSS", "JavaScript", "React", "TailwindCSS", "Git", "Vercel"],
  },
  // {
  //   slug: "web3-crypto-trading",
  //   title: "Web3 & Crypto Trading",
  //   short: "Understand blockchain basics and build disciplined trading strategies.",
  //   level: "Intermediate",
  // duration: "2 months",
  //   icon: "LineChart",
  // image: "/images/trading.webp",
  //   modules: [
  //     "Blockchain & wallets 101",
  //     "On‑chain metrics & tokenomics",
  //     "Risk mgmt & position sizing",
  //     "Trading plans & journals",
  //     "Backtesting setups",
  //     "Security & custody hygiene"
  //   ],
  //   outcomes: [
  //     "Evaluate projects with a framework",
  //     "Deploy and audit trading plans",
  //     "Track P&L with discipline",
  //     "Mitigate common security risks"
  //   ],
  //   tools: ["Etherscan", "DEXs", "TradingView", "Notion"],
  // },
  {
    slug: "graphic-designing",
    title: "Graphic Designing",
    short: "Craft brand‑ready visuals with typography, color, and composition mastery.",
    level: "Beginner → Intermediate",
  duration: "2 months",
    icon: "Paintbrush",
  image: "/images/graphic.webp",
    modules: [
      "Design principles & hierarchy",
      "Color systems & typography",
      "Brand kits & style guides",
      "Social creatives & ads",
      "Asset export & handoff",
      "Portfolio polish"
    ],
    outcomes: [
      "Build cohesive brand kits",
      "Deliver production‑ready assets",
      "Communicate rationale clearly",
      "Assemble a starter portfolio"
    ],
    tools: [ "Illustrator", "Photoshop", "Google Fonts"],
  },
  {
    slug: "video-editing",
    title: "Video Editing",
    short: "Edit compelling videos that hook, inform and convert across platforms.",
    level: "Beginner",
  duration: "2 months",
    icon: "Video",
  image: "/images/videoediting.webp",
    modules: [
      "Narrative arcs & shot selection",
      "Rhythm, pacing & cuts",
      "Motion graphics & titles",
      "Audio cleanup & soundbeds",
      "Color correction & grading",
      "Export presets & delivery"
    ],
    outcomes: [
      "Edit a short promo & explainer",
      "Design motion titles",
      "Deliver platform‑specific cuts",
      "Efficient file/org workflows"
    ],
    tools: ["Premiere Pro", "CapCut"],
  },
  {
    slug: "digital-marketing",
    title: "Digital Marketing",
    short: "Plan and run campaigns across SEO, content, social and paid acquisition.",
    level: "Beginner → Intermediate",
  duration: "2 months",
    icon: "Megaphone",
  image: "/images/digital-marketing.webp",
    modules: [
      "ICP & positioning",
      "SEO & content calendars",
      "Social playbooks",
      "Paid ads & creatives",
      "Analytics, funnels & LTV",
      "Experimentation cadence"
    ],
    outcomes: [
      "Ship a full‑funnel campaign",
      "Measure north‑star metrics",
      "Optimize creatives & spend",
      "Build a repeatable growth loop"
    ],
    tools: ["GA4", "GSC", "Meta Ads", "Canva", "Notion"],
  },
  {
    slug: "graphic-video-basics",
    title: "Basics of Graphic Design & Video Editing",
    short: "Master practical design and video editing skills through hands-on projects with Canva, Illustrator and CapCut.",
    level: "Beginner",
    duration: "2 months",
    icon: "Layers",
    image: "/images/course-winter.avif",
    modules: [
      "Canva design fundamentals",
      "Vector basics with Illustrator",
      "CapCut video editing essentials",
      "Social media content creation",
      "Daily practice & project work",
      "Portfolio development"
    ],
    outcomes: [
      "Create graphics from scratch",
      "Design social media posts & posters",
      "Edit short videos for platforms",
      "Build confidence with design tools"
    ],
    tools: ["Canva", "Adobe Illustrator", "CapCut"],
  },
  {
    slug: "computer-basics-kids",
    title: "Computer Basics & Digital Confidence",
    short: "Build essential computer skills, typing mastery, MS Office proficiency, and learn AI basics in a fun, kid-friendly environment.",
    level: "Beginner (Kids)",
    duration: "6 weeks",
    icon: "Monitor",
    image: "/images/winter-course.webp",
    modules: [
      "Computer fundamentals & file management",
      "Typing skills & keyboard mastery",
      "MS Office essentials (Word, PowerPoint, Excel)",
      "Internet basics & online safety",
      "AI for kids & technology awareness",
      "Hands-on projects & activities"
    ],
    outcomes: [
      "Navigate computers confidently",
      "Type efficiently with proper technique",
      "Create documents and presentations",
      "Use the internet safely and responsibly",
      "Understand AI basics through fun activities"
    ],
    tools: ["MS Word", "MS PowerPoint", "MS Excel", "Google Suite", "TypingClub", "Kid-friendly AI Tools"],
  },
];

export const coursesBySlug = courses.reduce((acc, c) => { acc[c.slug] = c; return acc; }, {});
export const courseSlugs = courses.map(c => c.slug);